/*
 * @Author: 张天昊
 * @Date: 2024-05-29 14:37:22
 * @LastEditTime: 2024-09-06 10:59:04
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/components/FilePreviewer/index.js
 */
export { default as FilePreviewer } from './FilePreviewer.vue';
export * from './fileType'
